import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    iconUrl: "assets/images/ic_dashboard.svg",
    iconUrlActive: "assets/images/ic_dashboard_active.svg",
    access: "dashboard",
  },
  // { state:'analytic', name: 'Analytics', type: 'link', icon: 'insert_chart_outlined', iconColor: '#FF5959', show: true },
  // { state: 'map', type: 'link', name: 'Map View',iconUrl: 'assets/images/ic_map.svg',iconUrlActive: 'assets/images/ic_map_active.svg', access: 'users' },
  {
    state: "merchant",
    type: "link",
    name: "Manage Merchant",
    iconUrl: "assets/images/ic_merchant.svg",
    iconUrlActive: "assets/images/ic_merchant_active.svg",
    access: "merchant",
  },
  // {
  //   state: "service-area",
  //   type: "link",
  //   name: "Service Area",
  //   iconUrl: "assets/images/ic_merchant.svg",
  //   iconUrlActive: "assets/images/ic_merchant_active.svg",
  //   access: "users",
  // },
  {
    state: "user-management",
    type: "link",
    name: "User",
    iconUrl: "assets/images/ic_user.svg",
    iconUrlActive: "assets/images/ic_user_active.svg",
    access: "users",
  },
    // { state: 'roles', type: 'link', name: 'Roles', iconUrl: 'assets/images/ic_role.svg',iconUrlActive: 'assets/images/ic_role_active.svg', access: 'roles' },
  {
    state: "payment-management",
    type: "link",
    name: "Invoices",
    iconUrl: "assets/images/ic_invoice.svg",
    iconUrlActive: "assets/images/ic_invoice_active.svg",
    access: "invoices",
  },
  {
    state: "driver-management",
    type: "link",
    name: "Drivers",
    iconUrl: "assets/images/ic_driver.svg",
    iconUrlActive: "assets/images/ic_driver_active.svg",
    access: "drivers",
  },
  {
    state: "order",
    type: "link",
    name: "Order",
    iconUrl: "assets/images/ic_order.svg",
    iconUrlActive: "assets/images/ic_order_active.svg",
    access: "order",
  },

  {
    state: "promo",
    type: "link",
    name: "Manage Coupon",
    iconUrl: "assets/images/ic_promo.svg",
    iconUrlActive: "assets/images/ic_promo_active.svg",
    access: "coupon",
  },
  // {
  //   state: "banner",
  //   type: "link",
  //   name: "Manage Banner",
  //   iconUrl: "assets/images/ic_banner1.svg",
  //   iconUrlActive: "assets/images/ic_banner1_active.svg",
  //   access: "banner",
  // },
  // {
  //   state: "pickdrop",
  //   type: "link",
  //   name: "Pick & Drop Settings",
  //   iconUrl: "assets/images/ic_pickdrop.svg",
  //   iconUrlActive: "assets/images/ic_pickdrop_active.svg",
  //   access: "pickDropSettings",
  // },
  {
    state: "fare",
    type: "link",
    name: "Manage Fares",
    iconUrl: "assets/images/RupeeBlack.svg",
    iconUrlActive: "assets/images/RupeeWhite.svg",
    access: "fares",
  },

  // {
  //   state: "refund",
  //   type: "link",
  //   name: "Refund",
  //   iconUrl: "assets/images/refund.svg",
  //   iconUrlActive: "assets/images/w-refund.svg",
  //   access: "refund",
  // },
  // {
  //   state: "menu",
  //   type: "link",
  //   name: "Influencer",
  //   iconUrl: "assets/images/influencer.svg",
  //   iconUrlActive: "assets/images/ic_menu_active.svg",
  //   access: "users",
  // },
  // {
  //   state: "influencers-management",
  //   type: "link",
  //   name: "Influencer",
  //   iconUrl: "assets/images/influencer.svg",
  //   iconUrlActive: "assets/images/influencer copy.svg",
  //   access: "influencer",
  // },
  {
    state: "city",
    type: "link",
    name: "Manage City",
    iconUrl: "assets/images/city.svg",
    iconUrlActive: "assets/images/city copy.svg",
    access: "city",
  },
  
  {
    state: "setting",
    type: "link",
    name: "Settings",
    iconUrl: "assets/images/ic_merchant.svg",
    iconUrlActive: "assets/images/ic_merchant_active.svg",
    access: "setting",
  },
  // {
  //   state: "audit",
  //   type: "link",
  //   name: "Audit Logs",
  //   iconUrl: "assets/images/ic_list.svg",
  //   iconUrlActive: "assets/images/ic_list_active.svg",
  //   access: "audit",
  // },
  // { state: 'operator', type: 'link', name: 'Operators', icon: 'perm_identity', iconColor: '#3AB89A', access: 'operators' },

  {
    state: "service-area-management",
    type: "link",
    name: "Service Area",
    iconUrl: "assets/images/service.svg",
    iconUrlActive: "assets/images/service copy.svg",
    access: "serviceArea",
  },
  // { state: 'reports-management', type: 'link', name: 'Reports', icon: 'subtitles',iconColor: '#FF5959', show: true,access: 'reports' },
  // { state: 'vehicle', type: 'link', name: 'Vehicles', icon: 'directions_car', iconColor: '#CF2D2D', access: 'vehicles' },
  // { state: 'driver-management', type: 'link', name: 'Drivers', icon: 'directions_car', svgIcon: 'driver', iconColor: '#4A3BD8', access: 'drivers' },
  //  { state:'payout', name: 'Payout', type: 'link', icon: 'av_timer',
  //  iconUrl: "assets/images/refund.svg",
  //  iconUrlActive: "assets/images/w-refund.svg",
  //   iconColor: '#FF5959', svgIcon:'payout', show: true,access: 'payout' },
    
    // { state:'transaction-history', name: 'Transaction History', type: 'link', icon: 'av_timer',
    // iconUrl: "assets/images/refund.svg",
    // iconUrlActive: "assets/images/w-refund.svg",
    //  iconColor: '#FF5959', svgIcon:'payout', show: true,access: 'payout' },
  // { state: 'stakeholder', type: 'link', name: 'Stakeholder', icon: 'group_add', svgIcon: 'expense', iconColor: '#4A3BD8',access: 'stakeholders' },
  // { state: 'passenger', type: 'link', name: 'Passengers', icon: 'emoji_people', iconColor: '#7D0CE4', access: 'passengers' },
  // { state: 'trips-management', type: 'link', name: 'Trips', icon: 'date_range', iconColor: '#C6B63B', access: 'trips' },
  // { state: 'terminal-management', type: 'link', name: 'Terminal/Bus Park', icon: 'date_range', svgIcon: 'terminal', iconColor: '#448700', access: 'terminals' },
  // { state: 'tracker-management/view-tracker', type: 'link', name: 'Covid-tracker', icon: 'date_range', svgIcon: 'covid', iconColor: '#FF8527', access: 'covidTracker' },
  // { state: 'covid', type: 'link', name: 'Covid-tracker', icon: 'date_range', svgIcon: 'covid', iconColor: '#FF8527', access: 'covidTracker' },
  // { state: 'password', type: 'link', name: 'Change Password', icon: 'lock', iconColor: '#24B5D7', show: true },
];

@Injectable()
export class MenuItems {
  constructor(private commonService: CommonService) {}
  getMenuitem(): Menu[] {
    const menuItems = MENUITEMS;
    menuItems.forEach((element) => {
      if (element.hasOwnProperty("access")) {
        const perm = this.commonService.getPermissions(element.access);
        element["show"] = perm !== "H";
      }
    });
    return menuItems;
  }
}
